import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/utils/cn';

const alertVariants = cva(
  'relative w-full rounded-lg border px-4 py-3 text-sm transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-surface-secondary border-border text-text-primary',
        warning: 'bg-warning/10 border-warning/20 text-warning',
        danger: 'bg-danger/10 border-danger/20 text-danger',
        success: 'bg-success/10 border-success/20 text-success',
        info: 'bg-info/10 border-info/20 text-info',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

const Alert = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof alertVariants>
>(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn(alertVariants({ variant }), className)}
    {...props}
  />
));
Alert.displayName = 'Alert';

const AlertTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h5
    ref={ref}
    className={cn('mb-1 font-medium leading-none tracking-tight', className)}
    {...props}
  />
));
AlertTitle.displayName = 'AlertTitle';

const AlertDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('text-sm opacity-90', className)} {...props} />
));

AlertDescription.displayName = 'AlertDescription';

export { Alert, AlertTitle, AlertDescription };

const CanvasKitJsAlert = () => {
  return (
    <Alert variant="warning" className="mt-4 mb-6">
      <AlertTitle>⚠️ Known Issues</AlertTitle>
      <AlertDescription>
        I am currently updating the article to support CanvasKitJs, which is
        causing some demos to break. Please note that the code will still work
        perfectly in your own apps.
      </AlertDescription>
    </Alert>
  );
};

export { CanvasKitJsAlert };
